import { useFetch } from "../../hooks/useFetch";
import LoadSimple from "../LoadSimple";
import Modal from "react-modal";
import ModalDeleteCis from "./ModalDeleteCis";
import { useState, useEffect } from "react";
import ModalCisAfecta from "./ModalCisAfecta";
import { lang } from "../generales/traduction";
import { capitalizeFirstLetter } from "../../utils/utils";
import Action from "../Action";
import PruebaSSH from "./PruebaSSH";
import SelectorAdmin from "../SelectorAdmin";
import { version } from "process";
const pingModalStyles = {
    content: {
      top: '50%',
      left: '50%',
      background: '#363636',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      width:'30%',
      height:'20%',
      padding:'20px'
    },
  };
  const configModalStyles = {
    content: {
      top: '50%',
      left: '50%',
      background: '#363636',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      width:'50%',
      height:'30%',
      padding:'20px'
    },
  };
const OperativeSistem = ({
    buscar_cis_history,
    handleChangEdit,
    cisSelected,
    server,
    languaje,
    handleShowPopup,
    mode
}) => {
  const [pingModalOpen, setPingModalOpen] =useState(false);

  function openPingModal() {
    setPingModalOpen(true);
  }

  function closePingModal() {
    setPingModalOpen(false);
  }
  const [configModalOpen, setConfigModalOpen] =useState(false);

  function openConfigModal() {
    setConfigModalOpen(true);
  }

  function closeConfigModal() {
    setConfigModalOpen(false);
  }
  const [credentials,setCredentials]=useState({
      hostid: cisSelected.hostid,
      so: "string",
      version: "string",
      
    })
  const [dataSoft,setDataSoft]=useState({
    data: [],
    loading: true,
    error: null,
  })
  useEffect(()=>{
    search_softwares()
  },[])
  const token_item=localStorage.getItem('access_token')
  const dataSO=useFetch('cassia/provisioning_softwares/operating_systems','',token_item,'GET',server)
  const search_softwares = () => {
    // setLoadingCis(true)
    setDataSoft({
      data: dataSoft.data,
      loading: true,
      error: dataSoft.error,
    });
    const fetchDataPost = async () => {
      try {
        const response = await fetch(
          server.url +
            "/api/v1/cassia/get_os_by_hostid/" +
            cisSelected.hostid,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );
        if (response.ok) {
          const data1 = await response.json();
          setCredentials((prevState)=>{
            return {
                ...prevState,
                ['so']:data1.data.operating_system_name
            }
            
        })
          setCredentials((prevState)=>{
              return {
                  ...prevState,
                  ['version']:data1.data.operating_system_version
              }
              
          })
          setDataSoft({
            data: data1,
            loading: false,
            error: dataSoft.error,
          });
          // setCreateCisModalOpen(true)
        } else {
          const data1 = await response.json();
          throw new Error("Error en la solicitud");
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchDataPost();
  };

  const [cisData,setCisData]=useState({hostid:'',os_id  :1})
  const [loading,setLoading]=useState(false)
  const Guardar=()=>{
    const data={
      "hostid": cisSelected.hostid,
      "os_id":cisData.os_id
    }
    setLoading(true)
    const fetchDataPost = async () => {
      
   try {
     // console.log(localStorage.getItem('access_token'))
     const response = await fetch(server.url+'/api/v1/cassia/update_os_by_hostid/'+cisSelected.hostid+"?os_id="+cisData.os_id, {
       method: 'POST',  
       headers: {
           'Content-Type': 'application/json',
           Authorization: `Bearer ${localStorage.getItem('access_token')}`,
         },
       // body: JSON.stringify(data),
     });
     if (response.ok) {
       
       const data1 = await response.json();
       setLoading(false)
       handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']),capitalizeFirstLetter((lang[languaje]['regEditCorr'])),'Sistema Operativo Actualizado', true)
       search_softwares()
       closeConfigModal()
     } else {
       const data1 = await response.json();
         handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['regNoGenCorr']),data1.detail, false)
         
       throw new Error('Error en la solicitud');
     }
   } catch (error) {
          
      setLoading(false)
        // Manejo de errores
        
        console.error(error);
      }
    };

    fetchDataPost();
  }
  const handleChange=(e)=>{
    const {name,value}=e.target

    setCredentials((prevState)=>{
        return {
            ...prevState,
            [name]:value
        }
        
    })
  }

  const changeOption=(option,index)=>{
    setCisData((prevState)=>{
        return {
            ...prevState,
            ['os_id']:option.value===""?0:(parseInt(option.value))
        }
        
    })
    // setCisRelation(option.value)
  }
  // not_installed
  const {so,version}=credentials
  return (
    <>
        <div className="cont-app-list">
            <div className="compact-app-list">
            {
                        (dataSoft.loading)?<LoadSimple/>:
                <div className="cont-form-ssh">
                   
                        <div className="form-GS-box">
                        <div className="user-box-GS" style={{height:'20%'}}>
                            <input required name="so" style={{background: "rgba(221, 221, 221, 0.33)"}}  placeholder='Seleccione Sistema Operativo' type="text" value={so}
                                onChange={handleChange} disabled  />
                                <label className='label-GS active ' style={{top: '-15%'}}>{capitalizeFirstLetter(lang[languaje]['operativeSistem'])}</label>
                                        
                        </div>
                        <div className="user-box-GS" style={{height:'20%'}}>
                            <input required name="version"  style={{background: "rgba(221, 221, 221, 0.33)"}} placeholder='Seleccione Sistema Operativo' type="text" value={version}
                                onChange={handleChange} disabled />
                                <label className='label-GS active ' style={{top: '-15%'}}>Version</label>
                                        
                        </div>
                        <div className="user-box-GS" style={{height:'20%'}}>
                                        {
                                            (loading)?<LoadSimple></LoadSimple>
                                            :
                                            <>
                                            <Action disabled={false} origen='Azul' titulo={capitalizeFirstLetter(lang[languaje]['configurar'])}  action={()=>{openConfigModal()}}/>
                                            {/* <Action disabled={false} origen='Azul' titulo={capitalizeFirstLetter(lang[languaje]['pruevaSsh'])}  action={()=>{openPingModal()}}/> */}
                                            </>
                                        }
                                            
                                    {
                                        // (registerIsValid && data.message!=="User deleted successfully")?<span className='form-msg-ok'>Usuario registrado correctamente</span>:''
                                    }
                                        
                                    </div>
                    </div>
                    
                </div>
                                }
            </div>
        </div>
        <Modal
          isOpen={pingModalOpen}
          // onAfterOpen={afterOpenExeption}
          onRequestClose={closePingModal}
          style={pingModalStyles}
          contentLabel="Example Modal2"
          // shouldCloseOnOverlayClick={false}
          >
            <PruebaSSH
             cisSelected={cisSelected}
             server={server}
             languaje={languaje}
             handleShowPopup={handleShowPopup}
             mode={mode}
             closePingModal={closePingModal}
             credentials={credentials}
            />
            {/* <PingModal actionSelected={actionSelected} server={server}isOpen={pingModalOpen} data={data} statusPing={statusPing} closePingModal={closePingModal}></PingModal> */}
        </Modal>
        <Modal
          isOpen={configModalOpen}
          // onAfterOpen={afterOpenExeption}
          onRequestClose={closeConfigModal}
          style={configModalStyles}
          contentLabel="Example Modal2"
          // shouldCloseOnOverlayClick={false}
          >
            <div className="modal-user-content">
            <div className='card-modal-gs modal-verificate'>
                <div className='head-card-modal-gs'>
                    <div className='title-head-card-modal-gs'>
                        {'CONFIGURAR SISTEMA OPERATIVO'}
                    </div>
                </div>
                <div className='content-card-modal-gs' style={{overflowY: 'scroll',scrollbarWidth: 'thin'}}>
                
                <div className="form-GS-box">
                <div className="user-box-GS" style={{height:'50%'}}>
                                        {
                                            (dataSO.loading)?'. . .':
                                            <SelectorAdmin placeholder={'Seleccionar tecnología...'} opGeneral={false} txtOpGen={''}  opt_de={1} origen={'Admin'} data={dataSO.data.data} loading={dataSO.loading}  titulo='SO' selectFunction={changeOption} index={0}></SelectorAdmin>

                                        }
                                    {/* <input required name="technology"  type="text" value={technology}
                                    onChange={handleChange} />*/}
                                        <label className='label-GS' style={{height:'10%'}}>{'SO'}</label> 
                                        {
                                            // (name==="" || nombreIsValid)?'':<span className='form-msg-error'> Nombre no valido</span>
                                        }
                                        
                                    </div>
                        {/* <div className="user-box-GS" style={{height:'25%'}}>
                            <input required name="user"  placeholder='Ingresa un usuario' type="text" value={user}
                                onChange={handleChange} disabled  />
                                <label className='label-GS active ' style={{top: '-15%'}}>Sistema Operativo</label>
                                        
                        </div>
                        <div className="user-box-GS" style={{height:'25%'}}>
                            <input required name="pass_"  placeholder='Ingresa una contraseña' type="text" value={pass_}
                                onChange={handleChange}  disabled />
                                <label className='label-GS active ' style={{top: '-15%'}}>Version</label>
                                        
                        </div> */}
                        <div className="user-box-GS" style={{height:'50%'}}>
                                        {
                                            (loading)?<LoadSimple></LoadSimple>
                                            :
                                            <>
                                            <Action disabled={false} origen='Cancelar' titulo={capitalizeFirstLetter(lang[languaje]['cancelar'])}  action={()=>{closeConfigModal()}}/>
                                            <Action disabled={false} origen='Azul' titulo={capitalizeFirstLetter(lang[languaje]['guardar'])}  action={()=>{Guardar()}}/>
                                            </>
                                        }
                                            
                                    {
                                        // (registerIsValid && data.message!=="User deleted successfully")?<span className='form-msg-ok'>Usuario registrado correctamente</span>:''
                                    }
                                        
                                    </div>
                    </div>
                </div>
                </div>
        </div>
          </Modal>
    </>
      
  );
};

export default OperativeSistem;
